import { createGlobalStyle } from 'styled-components';
import { lightColors, darkColors, cssVariableMap } from './tokens';

const generateCSSVariables = (colors) => {
  return Object.entries(colors)
    .map(([key, value]) => `${cssVariableMap[key]}: ${value};`)
    .join('\n    ');
};

const GlobalStyles = createGlobalStyle`
  html[data-theme="light"] {
    ${generateCSSVariables(lightColors)}
  }

  html[data-theme="dark"] {
    ${generateCSSVariables(darkColors)}
  }

  :root {
    --font-xs: 0.75rem;    /* 12px */
    --font-sm: 0.875rem;   /* 14px */
    --font-base: 1rem;     /* 16px */
    --font-md: 1.125rem;   /* 18px */
    --font-lg: 1.25rem;    /* 20px */
    --font-xl: 1.5rem;     /* 24px */
    --font-2xl: 2rem;      /* 32px */
    --font-3xl: 2.5rem;    /* 40px */
    --font-4xl: 3.5rem;    /* 56px */
    --leading-tight: 1.25;
    --leading-normal: 1.5;
    --leading-relaxed: 1.65;
  }

  body {
    background-color: var(--bg-primary);
    transition: background-color 0.3s ease, color 0.3s ease;
  }

  /* Smooth transition for theme changes */
  *, *::before, *::after {
    transition: background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;
  }

  /* Exclude elements that shouldn't transition (animations, transforms) */
  .aos-animate,
  [data-aos],
  .ant-picker-dropdown,
  .ant-select-dropdown,
  .ant-modal-mask {
    transition: none !important;
  }

  /* Focus-visible styles for keyboard navigation */
  *:focus-visible {
    outline: 2px solid var(--brand-primary);
    outline-offset: 2px;
  }

  /* Remove default focus outline for mouse users */
  *:focus:not(:focus-visible) {
    outline: none;
  }

  /* Respect reduced motion preferences */
  @media (prefers-reduced-motion: reduce) {
    *, *::before, *::after {
      animation-duration: 0.01ms !important;
      animation-iteration-count: 1 !important;
      transition-duration: 0.01ms !important;
      scroll-behavior: auto !important;
    }

    [data-aos] {
      opacity: 1 !important;
      transform: none !important;
    }
  }

  /* Skip to content link */
  .skip-to-content {
    position: absolute;
    top: -100%;
    left: 50%;
    transform: translateX(-50%);
    background: var(--brand-primary);
    color: var(--text-inverse);
    padding: 0.75rem 1.5rem;
    border-radius: 0 0 8px 8px;
    z-index: 10000;
    font-weight: 600;
    text-decoration: none;
    transition: top 0.2s ease;

    &:focus {
      top: 0;
    }
  }

  /* Fixed column background for sticky cells */
  .ant-table-cell-fix-right {
    background: var(--bg-primary, #faf7f2) !important;
  }

  /* Mobile table styles */
  @media (max-width: 767px) {
    .ant-table-cell {
      padding: 8px 6px !important;
      font-size: 0.85rem;
    }
    .ant-table-cell .ant-btn-sm {
      padding: 0 6px;
    }
    .ant-table-cell .ant-tag {
      margin-bottom: 2px;
    }
  }
`;

export default GlobalStyles;
